import moment from 'moment';

export const useFormatDate = (timestamp) => {
    if (timestamp) {
        const date = moment.unix(timestamp).format('MMMM, YYYY');
        
        return date.charAt(0).toUpperCase() + date.slice(1);
    } else {
        return null;
    }
}